import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IotGatewaysComponent } from './iot-gateways/iot-gateways.component';
import { RpCreateGatewayComponent } from './rp-create-gateway/rp-create-gateway.component';

const routes: Routes = [
  { path: 'iotgateways', component: IotGatewaysComponent },
  { path: 'iotgateways/creategateways', component: RpCreateGatewayComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class IotGateWaysRoutingModule {}
